import { Card, CardContent, Typography } from "@mui/material";
import { Box } from "@mui/system";

function GraphDataNotAvailable() {
  return (
    <Card sx={{ my: 2, boxShadow: 3, borderRadius: 2 }}>
      <CardContent>
        <Box sx={{ height: 300 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              color: "text.secondary",
            }}
          >
            <Typography variant="body1" color="text.secondary">
              No Data Available
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export { GraphDataNotAvailable };
